import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';
import { TabSdk } from '@techextensor/tab-sdk';

/**
 * Guard that checks if the user is authenticated.
 * If authenticated, allows access to the route.
 * If not authenticated, redirects to the sign-in page with an optional redirect URL.
 */
export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.check().pipe(
    map(authenticated => {
      if (authenticated) {
        return true;
      } else {
        const urlParts = window?.location?.pathname?.split(TabSdk.store.appName + '/screen/');
        let url = `/${TabSdk.store.appName}/sign-in`;
        if(!TabSdk.store.appName || TabSdk.store.appName === environment.commonConfig.applicationCode) {
          url = `/sign-in`;
        }

        // Parse the current URL's query parameters
        const queryParams = new URLSearchParams(window.location.search);

        // Check if the current URL contains a screen ID after the app code
        if (urlParts?.[1]) {
          // Construct the redirect URL with the screen ID
          url += `?redirectURL=${encodeURIComponent(urlParts[1])}`;

          // If there are query parameters, append them to the redirect URL
          if (queryParams.toString()) {
            url += `&${queryParams.toString()}`;
          }
        }

        return router.parseUrl(url);
      }
    })
  );
};
